import React, { useState, useEffect } from "react"
import "./InstallDirectPageMobile.scss"
import TMHBanner from "../../components/TMHBanner/TMHBanner"
import FirstSlide from "./slide1.png"
import SecondSlide from "./slide2.png"
import ThirdSlide from "./slide3.png"
import FourthSlide from "./slide4.png"
import Carousel from "react-bootstrap/Carousel"
import "bootstrap/dist/css/bootstrap.css"
import { useTitle } from 'react-use'
import ReactGA from "react-ga4"

const stepData = [
  {
    name: "Step 1",
    textNormal: "In your Roku, navigate to ",
    textRedColor: `"Search"`,
    description: `In your Roku, navigate to “Search”. If your Roku doesn't have this option, please `,
    descriptionIncludeHref: "click here for the Roku.com instructions🡵",
    descriptionHref: "/tmh/#/visit-roku-website",
    img: FirstSlide,
    altImg: "First slide",
  },
  {
    name: "Step 2",
    textNormal: "Search for",
    textRedColor: ` “The Movie House”`,
    textNormal2: ` & add channel`,
    description: `Using the keyboard on screen, type in “the movie house” and then hit “Add Channel” when it comes up on screen.`,
    img: SecondSlide,
    altImg: "Second slide",
  },
  {
    name: "Step 3",
    textNormal: `Open up and login to `,
    textRedColor: `“The Movie House”`,
    description: `Now that The Movie House is installed, you will see the app in your channels list. Navigate to it and open the app.`,
    img: ThirdSlide,
    altImg: "Third slide",
  },
  {
    name: "Step 4",
    textNormal: `Select`,
    textRedColor: ` “Sign In With Your Member PIN”`,
    description: `Once you open the app, select “Sign In With Your Member PIN”. Add your PIN to link your account. The Roku Movie Remote shows your Pin below the link you clicked to get to these instructions.`,
    img: FourthSlide,
    altImg: "Fourth slide",
  },
]

export default function InstallDirectPage() {
  const [title, setTitle] = useState("Install Direct - Mobile - The Movie House TV - Step 1")
  useTitle(title)
  useEffect(() => {
    ReactGA.send("pageview")
  })

  const [index, setIndex] = useState(0)

  const handleSelect = (selectedIndex, e=null) => {
    if (index === stepData.length - 1 && (selectedIndex === 0 || selectedIndex === stepData.length)) {
      return
    }
    // Prevent change slide if FirstSlide or LastSlide
    if (index === 0 && selectedIndex === stepData.length - 1) return
    setTitle("Install Direct - Mobile - The Movie House TV - Step " + String(selectedIndex + 1))
    ReactGA.send("pageview")
    setIndex(selectedIndex)
  }

  return (
    <TMHBanner classOption="only-gradient">
      <div className="redirect-page">
      <div className="redirect-background"/>
        <Carousel 
        nextIcon={index !== stepData.length - 1 ? <span class="carousel-control-next-icon" aria-hidden="true"></span> : null} 
        prevIcon={index !== 0 ? <span class="carousel-control-prev-icon" aria-hidden="true"></span> : null} 
        interval={null} activeIndex={index} onSelect={handleSelect}>
          {stepData.map((item, index) => (
            <Carousel.Item key={index}>
              <div className="step-wrapper">
                <h3 className="step">{item.name}</h3>
                <h3 className="headline">
                  {item.textNormal}
                  <span className="red-text">{item.textRedColor}</span>
                  {item.textNormal2 && item.textNormal2}
                  {item.textRedColor2 && (
                    <span className="red-text">{item.textRedColor2}</span>
                  )}
                </h3>
              </div>
              <img
                className="d-block w-100 slide-img"
                src={item.img}
                alt={item.altImg}
              />
              {(index !== stepData.length - 1 && <button onClick={()=>handleSelect(index+1)} className="next-step">NEXT STEP</button>)}
              <p className="description">
                {item.description}{" "}
                {item.descriptionIncludeHref ? (
                  <a
                    href={item.descriptionHref}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {item.descriptionIncludeHref}
                  </a>
                ) : null}
              </p>
            </Carousel.Item>
          ))}
        </Carousel>
      </div>
    </TMHBanner>
  )
}
